import { render, staticRenderFns } from "./AddIndexMenu.vue?vue&type=template&id=db9ece9e"
import script from "./AddIndexMenu.vue?vue&type=script&lang=js"
export * from "./AddIndexMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports